import { useEffect, useState, useMemo } from 'react';
import { ThemeContext, Theme } from '../theme-context';
import IThemeProviderProps from './IThemeProviderProps';

const ThemeProvider = ({ defaultTheme, storageKey = 'jtl-ui-theme', children }: IThemeProviderProps) => {
  const [theme, setTheme] = useState<Theme>(() => defaultTheme ?? (localStorage.getItem(storageKey) as Theme) ?? 'system');

  // Update data-color-scheme attribute when theme changes
  useEffect(() => {
    localStorage.setItem(storageKey, theme);
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    document.documentElement.dataset.colorScheme = theme === 'system' ? (mediaQuery.matches ? 'dark' : 'light') : theme;

    // listen for system appearance changes
    const updateTheme = (e: MediaQueryListEvent) => {
      if (theme === 'system') {
        document.documentElement.dataset.colorScheme = e.matches ? 'dark' : 'light';
      }
    };
    mediaQuery.addEventListener('change', updateTheme);
    return () => {
      mediaQuery.removeEventListener('change', updateTheme);
    };
  }, [theme, storageKey]);

  const value = useMemo(
    () => ({
      theme,
      setTheme,
    }),
    [theme],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export default ThemeProvider;
